import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlanLimitBanner = ({ usage, onUpgrade }) => {
  const { active_count, max_sites, usage_percentage, can_add_more } = usage || {};
  
  // Don't show banner for unlimited plans
  if (max_sites === null) return null;
  
  // Don't show if usage is below 80%
  if (usage_percentage < 80) return null;

  const isAtLimit = !can_add_more;
  const isNearLimit = usage_percentage >= 80 && usage_percentage < 100;

  return (
    <div
      className={`rounded-lg border p-4 md:p-6 mb-6 ${
        isAtLimit
          ? 'bg-destructive/10 border-destructive/30' :'bg-warning/10 border-warning/30'
      }`}
    >
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="flex-shrink-0">
            <Icon
              name={isAtLimit ? 'AlertCircle' : 'AlertTriangle'}
              size={24}
              color={isAtLimit ? 'var(--color-destructive)' : 'var(--color-warning)'}
            />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-foreground mb-1 text-sm md:text-base">
              {isAtLimit ? 'Active Site Limit Reached' : 'Approaching Your Site Limit'}
            </h3>
            <p className="text-sm text-muted-foreground mb-2">
              {isAtLimit ? (
                <>
                  You've used all <strong>{max_sites} active sites</strong> included in your plan.
                  Archiving a site will free up a slot. Upgrade your plan to add more active sites.
                </>
              ) : (
                <>
                  You're using <strong>{active_count} of {max_sites} active sites</strong> ({usage_percentage}%).
                  Consider upgrading before you reach your limit.
                </>
              )}
            </p>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Info" size={14} />
              <span>Archived sites do not count towards your active site limit</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 md:flex-shrink-0">
          <Button
            variant="default"
            size="sm"
            onClick={onUpgrade}
            className="w-full md:w-auto"
          >
            <Icon name="ArrowUpCircle" size={16} />
            Manage Subscription
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PlanLimitBanner;